import styled, { css } from 'styled-components';
import Button from '../../../../button';
import { IconContainer } from '../../../../icon';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS } from '../../../constants';
const BUTTON_ICON_SIZE = 20;
export const navigationItemActiveBarContainerStyles = ({ $isActive, }) => css `
	grid-area: ${NAVIGATION_GRID_AREAS.LEFT};
	display: ${$isActive ? 'flex' : 'none'};
	align-items: center;
`;
export const NavigationItemActiveBarContainer = styled.div `
	${navigationItemActiveBarContainerStyles}
`;
/**
 * Navigation sub item active bar button
 */
export const navigationItemActiveBarButtonStyles = ({ theme }) => css `
	flex: 0;
	padding: ${pxToRem(theme.spacing['200'])};
	margin: 0;
	cursor: pointer;
	border: none;
	gap: 0;
	font-size: 0;

	&:hover,
	&:focus {
		background: none;
		border: none;
	}

	${IconContainer} {
		width: ${pxToRem(BUTTON_ICON_SIZE)};
		height: ${pxToRem(BUTTON_ICON_SIZE)};
		color: ${theme.colors.highlight.iconInteractive};
	}
`;
export const NavigationItemActiveBarButton = styled(Button) `
	${navigationItemActiveBarButtonStyles}
`;
/**
 * Navigation sub item active bar link
 */
export const navigationItemActiveBarLinkStyles = ({ theme }) => css `
	margin: 0 auto;
	text-align: center;

	&:active {
		color: ${theme.colors.action.textActive};
	}
`;
export const NavigationItemActiveBarLink = styled(Typography).attrs({
    variant: 'button-link',
}) `
	${navigationItemActiveBarLinkStyles}
`;
